module.exports = __webpack_public_path__ + "static/media/frame_05.3139cdee.png";